import {ChangeDetectorRef, Component, HostListener, Inject, OnInit, Renderer2} from '@angular/core';
import {DOCUMENT, Location, PlatformLocation} from '@angular/common';
import {ActivatedRoute, NavigationStart, Router} from '@angular/router';
import {EventTrackerService, HttpService} from '@app/core';
import {ScrollToLastPosition} from '@app/helper/scroll-to-last-position';
import {IndicatorService} from '@app/shared';
import {environment} from '@env/environment';
import {filter} from 'rxjs/operators';
import {LibraryService} from '../library.service';
import {animate, state, style, transition, trigger} from "@angular/animations";

@Component({
  selector: 'navaar-list-library',
  templateUrl: './list-library.component.html',
  styleUrls: ['./list-library.component.scss', '../context-menu-library/context-menu-library.component.scss'],
  animations: [
    trigger('slide', [
      state('in', style({opacity: 1})),
      transition(':enter', [
        style({opacity: 0}),
        animate(150)
      ]),
      transition(':leave',
        animate(150, style({opacity: 0})))
    ])
  ]
})
export class ListLibraryComponent extends ScrollToLastPosition implements OnInit {
  @HostListener('window:popstate', ['$event'])
  onPopState(event) {
    if (this.isShowContextMenu) {
      this.isShowContextMenu = false;
    }
  }

  public isShowContextMenu: boolean = false;
  public tabNameContextMenu: 'bookmark' | 'library';
  public container: HTMLDivElement;
  public skip: number = 0;
  public title: string;
  public readonly PAGE_SIZE = 20;
  public pages: number = 0;
  public total: number = 0;
  public isLoading: boolean = false;
  public isEnd: boolean = false;
  public items: Array<any> = [];
  public slideAnimationPopup: string;
  public sortItems: Array<{ title: string, type: string, isSelected }> = [
    {title: "حروف الفبا", type: "Title", isSelected: false},
    {title: "نام نویسنده", type: "Author", isSelected: false},
    {title: "نام راوی", type: "Narrator", isSelected: false},
    {title: "آخرین اضافه شده ها", type: "CreateDate desc", isSelected: true}
  ];

  public get pageNo(): number {
    return this.pages;
  }

  public set pageNo(v: number) {
    this.pages = v;
  }

  private identifier: number;
  public readonly BASE_HREF_IMAGE = environment.imageUrl;

  constructor(
    @Inject(DOCUMENT) private readonly document: Document,
    private readonly platformLocation: PlatformLocation,
    private readonly location: Location,
    private readonly render: Renderer2,
    private readonly chkd: ChangeDetectorRef,
    private readonly http: HttpService,
    private readonly indicatorService: IndicatorService,
    private readonly activatedRoute: ActivatedRoute,
    private readonly libraryService: LibraryService,
    private readonly eventTracker: EventTrackerService,
    private readonly router: Router) {
    super(router);
    this.router.events
      .pipe(filter((event) => event instanceof NavigationStart))
      .subscribe((event: NavigationStart) => {
        if (event.restoredState) this.libraryService.isBackFromItem = true;
      });
  }

  ngOnInit(): void {
    this.activatedRoute.paramMap.subscribe(z => {
      this.identifier = +z.get('id');
      this.title = this.activatedRoute.snapshot.queryParams.title;
      this.tabNameContextMenu = this.activatedRoute.snapshot.queryParams.type;
      this.paginate(0);
    })
  }

  public paginate(page) {
    this.skip = page * this.PAGE_SIZE;
    this.pageNo = page + 1;
    this.libraryService.isBackFromItem = false;
    this.getListById(this.skip);
  }

  private getListById(skip) {
    this.isLoading = true;
    let Url = '';
    if (this.tabNameContextMenu === 'library')
      Url = `/api/library/all/${this.identifier}?$inlinecount=allpages`;
    else if (this.tabNameContextMenu === 'bookmark')
      Url = `/api/wishlist/all/${this.identifier}?$inlinecount=allpages`;
    else
      return;
    if (skip != undefined) {
      Url += `&$skip=${skip}`;
    }
    if (this.PAGE_SIZE != undefined) {
      Url += `&$top=${this.PAGE_SIZE}`;
    }
    Url += `&$orderby=` + this.sortItems.find(z => z.isSelected)?.type ?? 'Title';

    this.http.post(Url, {}).subscribe((c) => {
      let allItem = [];
      allItem = c.items;

      if (this.skip === 0) {
        this.items = [];
        this.items = allItem;
      }
      if (this.skip > 0) {
        allItem.forEach((value) => {
          this.items.push(value);
        });
      }

      this.isLoading = false;
      this.isEnd = this.items.length === c.count;
      this.total = c.count;
      this.pages = Math.ceil(this.total / this.PAGE_SIZE);
      this.indicatorService.hide();
      this.indicatorService.hideHude();
      this.chkd.detectChanges();
      if (this.libraryService.isBackFromItem) {
        super.scrollToPosition();
      }
    });
  }

  public analyticsEvent(identifier, title, index) {
    this.eventTracker.logEvent('x_pwa_library', {
      x_source_item_id: this.identifier,
      x_dest_item_id: identifier,
      "title-slider": this.title,
      x_dest_item_title: title,
      x_item_index: index
    });
  }

  public navigate(identifier, title) {
    this.router.navigate(["/pdp", identifier], {
      relativeTo: this.activatedRoute,
    }).then();
  }

  public showSortList() {
    this.isShowContextMenu = true;
    this.slideAnimationPopup = 'void';
    this.render.setStyle(this.document.body, 'overflow', 'hidden');
    this.platformLocation.pushState(null, null, this.location.path() + '#modalOpened');
  }

  public selected(item) {
    this.isLoading = true;
    this.sortItems.forEach(z => z.isSelected = false);
    this.sortItems.find(z => z.type === item.type).isSelected = true;
    this.indicatorService.showHude();
    this.isShowContextMenu = false;
    this.getListById(0);
  }

  public onSlidePopupAnimation(event: AnimationEvent) {
    if (this.isShowContextMenu === false) {
      if (this.location.path(true).includes('#modalOpened'))
        this.location.back();
      this.render.removeStyle(this.document.body, 'overflow');
    }
  }
}
